var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "me-box" }, [
      _c("div", { staticClass: "me" }, [
        _c("div", { staticClass: "userName" }, [_vm._v(_vm._s(_vm.user))]),
        _vm._v(" "),
        _c("div", { staticClass: "integration" }, [
          _vm._v("积分：" + _vm._s(_vm.integration))
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "le-list" },
      _vm._l(_vm.list, function(v, i) {
        return v.integration > 0
          ? _c("div", { key: i, staticClass: "le-info" }, [
              _c("div", { staticStyle: { display: "flex" } }, [
                i == 0
                  ? _c("div", { staticClass: "list-order-1" }, [
                      _vm._v(_vm._s(i + 1))
                    ])
                  : i == 1
                  ? _c("div", { staticClass: "list-order-2" }, [
                      _vm._v(_vm._s(i + 1))
                    ])
                  : i == 2
                  ? _c("div", { staticClass: "list-order-3" }, [
                      _vm._v(_vm._s(i + 1))
                    ])
                  : _c("div", { staticClass: "list-order" }, [
                      _vm._v(_vm._s(i + 1))
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-name" }, [
                  _vm._v(_vm._s(v.name) + " ( " + _vm._s(v.mapperNumber) + " )")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "list-league" }, [
                _c("img", {
                  staticStyle: {
                    width: "0.12rem",
                    height: "0.16rem",
                    "margin-right": "0.05rem"
                  },
                  attrs: { src: require("../../../assets/point.png") }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(v.integration))])
              ])
            ])
          : _vm._e()
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-pic" }, [
      _c("img", {
        staticStyle: { width: "100%", height: "100%", border: "none" },
        attrs: { src: require("../../../assets/jifen.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "top-empty" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-box" }, [
      _c("div", { staticClass: "le-title" }, [
        _c("div", { staticClass: "le-left" }, [
          _c("div", { staticClass: "le-index" }, [_vm._v("排名")]),
          _vm._v(" "),
          _c("div", { staticClass: "le-name" }, [_vm._v("姓名")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "le-num" }, [_vm._v("积分")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb03f4d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb03f4d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/model/list/league.vue
// module id = null
// module chunks = 